import report from "../../api/report";
import { perPageCount } from "@/common/constants";
import {
  percentageVieW,
  dummyRows,
  StatusIcon,
  convertCount,
} from "@/common/functions";

const getDefaultState = () => {
  return {
    items: [],
    loaded: false,
    filter: {
      page: 1,
      per_page_count: perPageCount,
      camp_name: "",
      search_date_from: "",
      search_date_to: "",
      search_sender_id: "",
      search_status: "",
      _route: "autoresponder_report",
      exportData: 0,
      sort_field: "scheduleDate",
      sort_order: "desc",
      add_sort: 0,
    },
    totalItems: 0,
    exportError: "",
    total: 0,
    busyLoaderStatus: true,
    showFilter: false,
  };
};

// initial state
const state = getDefaultState();

// getters
const getters = {
  getItems: (state) => {
    if (!state.items.length && !state.loaded) {
      return dummyRows();
    }

    return state.items.map((item) => {
      var status = item.statusname;
      var icon = StatusIcon(status);

      var sentPer =
        percentageVieW(
          item.sentto,
          item.type === 4 ? item.maxLimit : item.queuedTotal
        ) + "%";
      var clickPer = percentageVieW(item.clicks, item.opens) + "%";
      // var openPer = percentageVieW(item.opens, item.sentto) + '%'
      var unsubs = percentageVieW(item.unsubs, item.opens) + "%";
      return {
        id: item.id,
        campName: {
          title: item.campName,
          text: item.scheduleDate,
          subjectline: item.campSubject,
        },
        cam_status: { text: status, type: icon, time: item.statusChangeDate },
        sentto: { first: convertCount(item.sentto), second: sentPer },
        isAmp: [3, 4].includes(item.contenttype),
        openRate: {
          first: item.openRate + "%",
          second: convertCount(item.opens),
        },
        clicks: { first: convertCount(item.clicks), second: clickPer },
        unsubs: { first: convertCount(item.unsubs), second: unsubs },
      };
    });
  },
};

// actions
const actions = {
  fetchItems({ commit, state }, params) {
    var filter = state.filter;
    if (
      !state.loaded ||
      filter.page !== params.page ||
      filter.per_page_count !== params.per_page_count ||
      filter.camp_name !== params.camp_name ||
      filter.search_date_from !== params.search_date_from ||
      filter.search_date_to !== params.search_date_to ||
      filter.search_sender_id !== params.search_sender_id ||
      filter.search_status !== params.search_status
    ) {
      commit("setFilter", { ...params });
      return new Promise(function (resolve) {
        report.fetchItems(params, (data) => {
          commit("setItems", { items: data.items });
          commit("setTotalItems", data.total);
          commit("setLoaded", true);
          commit("setBusyLoaderStatus", true);
          resolve(data.total);
        });
      });
    }
  },
  exportItems(_, params) {
    var name = params._route + ".csv";
    return report.exportItems(params, { name });
  },
  refreshItems({ commit, state, dispatch }) {
    commit("setLoaded", false);
    dispatch("fetchItems", state.filter);
  },
  resetState({ commit }) {
    commit("resetState");
  },
};

// mutations
const mutations = {
  setItems(state, { items }) {
    state.items = items;
  },

  setFilter(state, data) {
    state.filter = data;
  },

  setTotalItems(state, total) {
    state.totalItems = total;
  },

  setLoaded(state, loaded) {
    state.loaded = loaded;
  },
  setExportError(state, data) {
    state.exportError = data;
  },
  setTotal(state, total) {
    state.total = total;
  },
  setBusyLoaderStatus(state, status) {
    state.busyLoaderStatus = status;
  },
  resetState(state) {
    Object.assign(state, getDefaultState());
  },
  setShowFilter(state, status) {
    state.showFilter = status;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
